import React from 'react';

/* eslint-disable */
const Careers = ({ body }) => {
    return (
        <div className="main-content-body-inner-container">
            <div className="main-content-body-title">
                CAREERS
            </div>
            <div className="main-content-text-container main-content-body-scrollable-box">
                {body ? (
                    <div
                    className="body-html-box"
                    dangerouslySetInnerHTML={{ __html: body }}
                    />
                ) : null}
            </div>
        </div>
    );
};

export default Careers;



// WEBPACK FOOTER //
// ./src/Theme/Careers.jsx